import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { Fragment } from "react";
import LogoHeader from "./LogoHeader";
import { amountFormat } from "../../../../utils";
const ReportsMainHeaderOne = ({ data }) => {
  const styles = StyleSheet.create({
    container: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    // 💡 NEW STYLE: Define the width for the left-side container
    leftContainer: { 
      width: "60%", // e.g., Set to 60% of the total width
    },
    CompanyHeader: {
      fontSize: "15px",
      fontWeight: 600,
      color: "#4B5660",
    },
    addresses: {
      fontSize: "11px",
      fontWeight: 900,
      color: "#818181",
      opacity: "0.5",
    },
    // ... (rest of the styles)
    directionRow: {
      flexDirection: "row",
    },
    lightHeader: {
      fontSize: "11px",
      fontWeight: "500",
      color: "#00000099",
      opacity: "0.5",
      marginRight: "10px",
    },
    darkHeader: {
      fontSize: "10px",
      fontWeight: "500",
      color: "#141414F4",
    },
    rightContainer: {
      flexDirection: "column",
      alignItems: "flex-end",
      width: "40%", // e.g., Remaining width for the right side
    },
    amount: {
      fontSize: "17px",
      fontWeight: "900",
      color: "#4B5660",
    },

    header: {
      width: "100%",
      height: 20,
      flexDirection: "row",
    },
    leftBar: {
      width: "75%",
      backgroundColor: "#003366",
      height: 20,
    },
    rightBar: {
      width: "24.5%",
      backgroundColor: "#ed3338",
      height: 20,
    },
    whiteBar: {
      width: "0.5%",
      backgroundColor: "#ffffff",
      height: 20,
    },
    logoSection: {
      width: "100%",
      paddingTop: 10,
      paddingBottom: 10,
      position: "relative",
      height: 60,
    },
    logoImage: {
      maxHeight: 40,
      width: 100,
      right: 0,
      position: "absolute",
    },
  });
  console.log({ data });

  return (
    <Fragment>
      <LogoHeader />
      <View style={styles.container}>
        {/* 💡 APPLY THE NEW STYLE HERE */}
        <View style={styles.leftContainer}> 
          <View>
            <Text style={styles.CompanyHeader}>
              {data?.pdf_details?.company_name
                ? data?.pdf_details?.company_name
                : "-"}
            </Text>
          </View>
          {/* The Text component handles wrapping automatically within its parent's width */}
          <View>
            <Text style={styles.addresses}>
              {data?.pdf_details?.company_address
                ? data?.pdf_details?.company_address
                : "-"}
            </Text>
          </View>
          <View style={styles.directionRow}>
            <Text style={styles.lightHeader}>GSTIN </Text>
            <Text style={styles.darkHeader}>
              {data?.pdf_details?.company_gst
                ? data?.pdf_details?.company_gst
                : "-"}
            </Text>
          </View>
        </View>
        <View style={styles.rightContainer}>
          <View>
            <Text style={styles.CompanyHeader}>{data?.title}</Text>
          </View>
          <View style={styles.directionRow}>
            <Text style={styles.lightHeader}>Report Number</Text>
            <Text style={styles.darkHeader}>
              {data?.report_number ? data?.report_number : "-"}
            </Text>
          </View>
          <View>
            <Text style={styles.darkHeader}>Amount to be Reimbursed</Text>
          </View>
          <View>
            <Text style={styles.amount}>
              INR{" "}
              {amountFormat(
                data?.total_amount -
                  data?.total_non_reimbursable_amount -
                  data?.total_advances_amount
              )}
            </Text>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default ReportsMainHeaderOne;